/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: video-metadata-component.ts
 *
 * Created by randysorensen on 9/12/18.
 */

function VideoMetadataController (
    this: JS5Object,
    _: JS5Object,
    DynamicPropertiesService: JS5Object,
    ModalService: JS5Object,
    PackageMediaService: JS5Object
) {

    this.getPackageObject = (): JS5Object => {
        return PackageMediaService.packageObject;
    };

    this.getMainVideo = (): JS5Object => {
        return PackageMediaService.getMainVideo();
    };


    //================//
    // Template Logic //
    //================//

    this.showMasterVideoKindDD = () => {
        let videoMasterType = _.get(PackageMediaService.getPrimaryAcceptTemplateMember(), `acceptProfile.videoMasterType.type`);
        return videoMasterType === 'MASTER_VIDEO';
    };

    this.hasMainVideo = () => {
        return !!_.get(this.getMainVideo(), `virtualPath`, null);
    };

    this.onHelpClicked = (context: string) => {
        let message = '';
        let title = '';

        switch (context) {
            case 'burnedSub':
                message =
                    `Subtitles can either be a form of written translation of a dialog in a foreign language, or a` +
                    ` written rendering of the dialog in the same language, with or without added information to help` +
                    ` viewers who are deaf and hard of hearing to follow the dialog. Subtitles can also be for people` +
                    ` who cannot understand the spoken dialogue or who have problems understanding a person’s spoken` +
                    ` accent. Opening title sequences and credits are not considered “subtitles” in this case.`;
                title = 'Burned-in Subtitles';
                break;

            case 'narrativeBurned':
                message =
                    `Narrative text is text that appears on screen to supplement the plot of the story without the` +
                    ` use the use of a narrator, such as “Earlier that morning”, “2 A.M.” or “Sydney, Australia.”` +
                    ` Opening title sequences and credits are not considered “text” in this case.`;
                title = 'Narrative Burned-in Text';
                break;

            case 'recap':
                message =
                    `This is the timecode at which the recap at the top of the program has concluded, but before the` +
                    ` main program has started. This may or may not be a clean point in time. For example an` +
                    ` audio/video dip to black between recap and program would be considered ‘clean’, whereas a` +
                    ` cross-fade from the recap to the main program would not be considered “clean”. If the recap` +
                    ` ending timecode is a clean point in time, identify this as a ‘clean’ recap ending timecode.`;
                title = 'Recap Ending Timecode';
                break;
        }

        ModalService.showMessageModal({
            messageText: message,
            title: title,
            cancelText: 'OK'
        });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        DynamicPropertiesService.queryForProperties()
            .then(() => {
                this.availableMediaVersions = DynamicPropertiesService.getPropValueAsList('package.mediaVersions');
                this.availableRevisions = _.range(1, 51);
                this.masterVideoKinds = DynamicPropertiesService.getPropValueAsList('package.masterVideoKind');
                return PackageMediaService.getPackageMediaData();
            }).then(() => {
                this.languages = PackageMediaService.packageMediaData.languages;
            });
    };

}

angular.module('prism-ui.package').component(
    'videoMetadata',
    {
        controller: VideoMetadataController,
        templateUrl: 'package/editor/components/view/media/components/videoMetadata/video-metadata-template.html',
        bindings: {
        }
    });
